import { useContext, useEffect, useState } from 'react';
import { Button, Icon }                    from 'semantic-ui-react';
import AppContext                          from '../../../context/HeaderContext';
import BasicPaginatedTable                 from '../../../components/table/BasicPaginatedTable';
import CenterCell                          from '../../../components/table/CenterCell';
import Loading                             from '../../../components/Loading';
import JiraLink                            from '../../../components/JiraLink';
import { getAPI }                          from '../../../libs/fetchAPI';

function RawConsecutiveFailures() {
	const { current_project_id }  = useContext(AppContext);
	const [ results, setResults ] = useState(false);

	useEffect(() => {
		getAPI(`/reports/consecutive_failures?project_id=${current_project_id}`).then((response) => {
			console.log(`Response`, response.data);
			setResults(response.data);
		});
	}, [current_project_id, setResults]);

	const columns = [
		{
			Header   : `Spec File`,
			accessor : `spec_file`,
			Cell     : ({ cell }) => <JiraLink issue_key={cell.value} />
		},
		{
			Header   : `Title`,
			accessor : `title`,
		},
		{
			Header   : `Last Passed Date`,
			accessor : `last_passed_date`,
		},
		{
			Header   : `Last Run Date`,
			accessor : `last_run_date`,
		},
		{
			Header   : `Version`,
			accessor : `version`,
		},
		{
				Header         : ``,
				accessor       : `id`,
				collapse       : true,
				disableFilters : true,
				Cell           : ({ cell }) => {
					const row    = cell.row.values;
					const params = {
						spec_file : row.spec_file,
						version   : row.version || ``,
					};

					const link = `${window.location.origin}/suites/single?${new URLSearchParams(params)}`;

					return (
						<CenterCell>
							<a href={link} target="_blank" rel="noreferrer">
								<Button primary>
									<span>History</span>
									<span>&nbsp;&nbsp;<Icon name="external" /></span>
								</Button>
							</a>
						</CenterCell>
					);
				}
		}
	];

	if(!results) {
		return <Loading />
	}

	return (
		<>
			<BasicPaginatedTable
				columns={columns}
				data={results}
				default_page_size="25"
			/>
		</>
	)
}

export default RawConsecutiveFailures;
